import { createFileRoute } from '@tanstack/react-router';
import { SegmentsListRouteView } from '@/pages/workspaces/segments/routing';
import { LastWorkspaceResolver } from './-components';

function SegmentsRoute() {
  return (
    <LastWorkspaceResolver>
      <SegmentsListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/segments/')({
  component: SegmentsRoute,
});
